import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    useBulkKit: number,
    donorId: number,
    centerId: number,
    existingTyping: boolean,
    existingRequestForTyping: boolean,
    alias: string,
    onCancel: () => void;
}

const ExpertSystemEnrollmentResponse = (props: IProps) => {
    //const swabPath = __OUTSIDEURL__ + '/centers/histogenetics/bulk-donor-cheek-swab.php?donorId=' + props.donorId;

    let swabPath = `/center/${props.centerId}/cheek-swab-request/donor/${props.donorId}`;

    return (
        <Modal backdrop="static" show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                Expert System Enrollment ({props.alias})
            </Modal.Header>
            <Modal.Body>
                {props.useBulkKit == 1 &&
                    <p>
                        You have selected to use a bulk cheek swab. You will need to print a requisition, and that can be done by clicking{' '}
                        <a href={swabPath} target="_blank">here</a> and filling out the form.
                    </p>
                }

                {props.useBulkKit == 0 &&
                    <p>
                        You have selected to have a kit shipped to the donor ({props.alias}).<br/>This kit should arrive at the donor's address within the next 1 to 2 business days.
                    </p>
                }

                {props.useBulkKit != 1 && props.useBulkKit != 0 &&
                    <>Thank you for your Expert System Enrollment.</>
                }

                {props.existingRequestForTyping &&
                    <p>
                        A request for typing has already been made for the donor ({props.alias}).
                    </p>
                }

                {props.existingTyping &&
                    <p>
                        Typing already exists for the donor ({props.alias}).
                    </p>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle="primary" onClick={props.onCancel}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ExpertSystemEnrollmentResponse;
